webpackJsonp([73896326755509],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-bottom: 2rem;\n"], ["\n  margin-bottom: 2rem;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var weights = [100, 200, 300, 400, 500, 600, 700, 800];
	
	var Section = _styledComponents2.default.div(_templateObject);
	
	var Fonts = function Fonts(props) {
	  var variants = weights.map(function (w) {
	    return _react2.default.createElement(
	      "div",
	      {
	        style: {
	          display: "flex",
	          marginBottom: "1rem",
	          fontSize: "1rem",
	          fontWeight: w
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { style: { marginRight: "20px" } },
	        w
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          "Dolor alias sapiente et veniam error similique qui."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { fontStyle: "italic" } },
	          "Dolor alias sapiente et veniam error similique qui."
	        )
	      )
	    );
	  });
	
	  var fontSizes = new Array(props.theme.fontSizes.length).fill().map(function (_, i) {
	    return _react2.default.createElement(
	      "div",
	      { style: { marginTop: "2rem" } },
	      _react2.default.createElement(
	        "div",
	        { style: { fontSize: "12px" } },
	        i,
	        " = ",
	        props.theme.fontSizes[i]
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        { style: { whiteSpace: "nowrap" }, key: i, f: i },
	        "Dolor alias sapiente et veniam error similique qui."
	      )
	    );
	  });
	
	  var spaces = new Array(props.theme.space.length).fill().map(function (_, i) {
	    return _react2.default.createElement(
	      "div",
	      { style: { marginTop: "2rem" } },
	      _react2.default.createElement(
	        "div",
	        { style: { fontSize: "12px" } },
	        i,
	        " = ",
	        props.theme.space[i]
	      ),
	      _react2.default.createElement("div", {
	        style: {
	          background: "black",
	          width: "100%",
	          height: props.theme.space[i]
	        }
	      })
	    );
	  });
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Spaces"
	      ),
	      spaces
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Variants"
	      ),
	      variants
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Sizes"
	      ),
	      fontSizes
	    )
	  );
	};
	
	exports.default = (0, _styledComponents.withTheme)(Fonts);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fonts-js-4fb3cd52406fd6480de8.js